import {Table, TBody, Td, Th, Thead, Tr} from '@/components/Table/Table';
import type {AfriexAdminUser, AfriexBusinessLog} from '@/types';
import * as formatDate from '@/utils/date';

const LogsTable = ({items}: {items: AfriexBusinessLog[]}) => {
  return (
    <Table>
      <Thead>
        <Tr enableHover={false}>
          <Th className="pl-6">Initiator</Th>
          <Th className="px-5">Initiator Role</Th>
          <Th>Description</Th>
          <Th>Date Initiated</Th>
        </Tr>
      </Thead>
      <TBody>
        {items.map((item, index) => (
          <LogsTableRow key={index} item={item} index={index} />
        ))}
      </TBody>
    </Table>
  );
};

const LogsTableRow = ({
  item,
  index,
}: {
  item: AfriexBusinessLog;
  index: number;
}) => {
  const admin = item?.meta?.admin as unknown as AfriexAdminUser;
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';

  return (
    <Tr className={zebraRow}>
      <Td className={`pl-6 font-medium`}>{admin?.name}</Td>
      <Td className={`px-5 font-medium `}>{admin?.role}</Td>
      <Td className={`font-medium`}>{item?.message}</Td>
      <Td>{formatDate.DDMonYYYY(item.createdAt || '', true)}</Td>
    </Tr>
  );
};

export default LogsTable;
